import { render, staticRenderFns } from "./budgets-rollover-list.vue?vue&type=template&id=7bf91e92"
import script from "./budgets-rollover-list.vue?vue&type=script&lang=js"
export * from "./budgets-rollover-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports